import styled from 'styled-components'

export const EmptyContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
export const EmptyTitle = styled.h3`
  font-size: 18px;
  margin-bottom: 32px;
  line-height: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.secondary.normal};

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    font-size: 24px;
    line-height: 32px;
  }
`

export const EmptySubtitle = styled.h4`
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  margin-bottom: 60px;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    font-size: 18px;
    line-height: 24px;
  }
`
export const EmptyImg = styled.img``